import { PatientIntakeConsultationSummaryV1 } from "~/providers/utils/types/patientIntakePreviewTypes";
import {
  PatientScreeningConsultationSummaryV1,
  SUMMARY_TYPE,
} from "~/providers/utils/types/patientPreviewTypes";
import { isFeedbackLiked } from "./isFeedbackLiked";

interface GetConsultationSummaryDataProps {
  screeningSummary: PatientScreeningConsultationSummaryV1;
  intakeSummary?: PatientIntakeConsultationSummaryV1;
}

export const getConsultationSummaryV1Data = ({
  screeningSummary,
  intakeSummary,
}: GetConsultationSummaryDataProps) => {
  const {
    id: screeningSummaryId,
    feedbacks: screeningFeedbacks,
    data: {
      long_summary: longSummaryScreening,
      significant_clinical_dimensions: significantClinicalDimensions,
      medications,
      scores,
    },
  } = screeningSummary;

  const {
    id: intakeSummaryId,
    feedbacks: intakeFeedbacks,
    data: intakeSummaryData,
  } = { ...intakeSummary };

  const {
    long_summary: longSummaryIntake,
    functional_domains: functionalDomains,
    symptom_progression: symptomProgression,
    treatment_recommendations: treatmentRecommendations,
  } = { ...intakeSummaryData };

  const isSummaryLiked = intakeSummaryId
    ? isFeedbackLiked(SUMMARY_TYPE.intake, intakeFeedbacks)
    : isFeedbackLiked(SUMMARY_TYPE.screening, screeningFeedbacks);

  const isTreatmentRecommendationsLiked = isFeedbackLiked(
    SUMMARY_TYPE.treatment_recommendations,
    intakeFeedbacks,
  );

  const longSummary = longSummaryIntake ?? longSummaryScreening;

  return {
    screeningSummaryId,
    intakeSummaryId,
    isSummaryLiked,
    isTreatmentRecommendationsLiked,
    longSummary,
    significantClinicalDimensions,
    medications,
    scores,
    functionalDomains,
    symptomProgression,
    treatmentRecommendations,
  };
};
